export default function getSrc(url: string, size: number): string {
	return url.replace('{width}', size.toString());
}
